import React from 'react'

const PaymentCallback: React.FC = () => {
  return <div>Loading...</div>
}

export default PaymentCallback
